import CustomAccordian from "../../components/CustomAccordian";
import '../../assets/css/Personalise.css';
import { useEffect, useState } from "react";
import CustomButton from "../../components/CustomButton";
import CustomDatePicker from "../../components/CustomDatePicker";
import DatePicker from "react-datepicker";
import { apiHandler } from '../../assets/api';
import { endpoint } from '../../assets/api/endpoint';
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import axios from 'axios';
import { saveFilterGameUpdating } from "../../redux/UserDataSlice";
import FilterLocation from "../../components/FilterLocation";

const METERS_TO_MILES = 0.000621371;

const FilterPage = ({ onCancel, onApplyFilter, onClearFilter, clearFilter }) => {
    const [selectedLevel, setSelectedLevel] = useState([]);
    const [selectedSports, setSelectedSports] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState("Profile Location");
    const [distance, setDistance] = useState(50);
    const { accessToken, profileData, filterGameUpdating, filterUpdating } = useSelector((state) => state.loginInfo);
    const [location, setLocation] = useState({ latitude: null, longitude: null })
    const [profileLocation, setProfileLocation] = useState();
    const [endDate, setEndDate] = useState()
    const [selectedTimeRanges, setSelectedTimeRanges] = useState([]);
    const [selectedDays, setSelectedDays] = useState([]);
    const [otherLocation, setOtherLocation] = useState();
    const [currentLocation, setCurrentLocation] = useState();
    const [locationResults, setLocationResults] = useState([]);
    const [selectedCoordinatesOther, setSelectedCoordinates] = useState({ latitude: null, longitude: null });
    const [isClearDisabled, setIsClearDisabled] = useState(false);
    const [formattedEndDate, setFormattedEndDate] = useState();
    const [currentCoordinates, setCurrentCoordinates] = useState({ latitude: '', longitude: '' });
    const dispatch = useDispatch();


    const handleSportChange = (sport) => {
        if (selectedSports?.includes(sport)) {
            setSelectedSports(selectedSports?.filter((s) => s !== sport));
        } else {
            setSelectedSports([...selectedSports, sport]);
        }
    };

    const timeRanges = [
        { label: "Early Morning (5 am - 8 am)", value: "early_morning" },
        { label: "Morning (8 am - 12 pm)", value: "morning" },
        { label: "Afternoon (12 pm - 4 pm)", value: "afternoon" },
        { label: "Evening (4 pm - 8 pm)", value: "evening" },
        { label: "Late Evening (8 pm - 10 pm)", value: "late_evening" },
    ];

    const days = [
        { label: "Monday", value: "monday" },
        { label: "Tuesday", value: "tuesday" },
        { label: "Wednesday", value: "wednesday" },
        { label: "Thursday", value: "thursday" },
        { label: "Friday", value: "friday" },
        { label: "Saturday", value: "saturday" },
        { label: "Sunday", value: "sunday" },
    ];
    useEffect(() => {
        setFormattedEndDate(endDate ? new Date(endDate).toLocaleDateString('en-CA') : '');
    }, [endDate])

    const handleTimeRangeChange = (value) => {
        setSelectedTimeRanges((prev) =>
            prev.includes(value) ? prev?.filter((v) => v !== value) : [...prev, value]
        );
    };

    const handleDayChange = (value) => {
        setSelectedDays((prev) =>
            prev.includes(value) ? prev?.filter((v) => v !== value) : [...prev, value]
        );
    };

    const handleLevelChange = (value) => {
        setSelectedLevel(prev =>
            prev.includes(value)
                ? prev?.filter(item => item !== value)
                : [...prev, value]
        );
    };

    const getLocationName = async (lat, lng) => {
        const apiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

        try {
            const response = await fetch(url);
            const data = await response.json();

            if (data.status === 'OK') {
                const address = data.results[0]?.formatted_address;
                return address;
            } else {
                console.error('Geocoding error:', data.status);
                return null;
            }
        } catch (error) {
            console.error('Error fetching location:', error);
            return null;
        }
    };
    const onLocationChange = (selectlocation) => {
        setLocation(selectlocation)
    }

    useEffect(() => {
        getLocationName(profileData?.baseProfile?.latitude, profileData?.baseProfile?.longitude)
            .then((address) => {
                setProfileLocation(address)
            });

        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    const { latitude, longitude } = position.coords;
                    setCurrentCoordinates({ latitude, longitude });
                    localStorage.setItem("coordinates", JSON.stringify({ latitude, longitude }));

                    getLocationName(latitude, longitude)
                        .then((address) => {
                            setCurrentLocation(address)
                        });
                },
                (error) => {
                    console.error('Error fetching location:', error);
                }
            );
        }
    }, [])

    useEffect(() => {
        const fetchLocation = async () => {
            if (otherLocation?.length >= 3) {
                try {
                    const response = await axios.get('https://maps.googleapis.com/maps/api/geocode/json', {
                        params: {
                            address: otherLocation,
                            key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
                        }
                    });

                    if (response.data.results && response.data.results.length > 0) {
                        const locations = response.data.results.map(result => ({
                            name: result.formatted_address,
                            lat: result.geometry.location.lat,
                            lng: result.geometry.location.lng
                        }));
                        setLocationResults(locations);
                    } else {
                        setLocationResults([]);
                    }
                } catch (error) {
                    console.error('Error fetching location:', error);
                }
            } else {
                setLocationResults([]);
            }
        };

        const delayDebounceFn = setTimeout(fetchLocation, 500);

        return () => clearTimeout(delayDebounceFn);
    }, [otherLocation]);

    const handleApplyFilter = async () => {
        if (!selectedSports || selectedSports.length === 0) {
            toast.error("Please select a sport before applying the filter");
            return;
        }
        setIsClearDisabled(true);
        const filters = {
            maxDistance: distance * 1609.34, // converting miles into meters
            longitude: location.longitude,
            latitude: location.latitude,
            sportName: selectedSports,
            skillLevel: selectedLevel.length > 0 ? selectedLevel.map(level => level.toUpperCase().replace(/-/g, '_').replace(/\s+/g, '_')) : [],
            timeSlots: selectedTimeRanges.map((time) => time.toUpperCase()),
            days: selectedDays.map((day) => day.toUpperCase()),
            endDate: formattedEndDate
        };

        try {
            const result = await apiHandler({
                url: endpoint.FILTER_GAME_DATA,
                method: "POST",
                authToken: accessToken?.accessToken,
                data: filters
            });

            const response = result?.data?.message;

            if ((response == "Filter created" || "Filter updated") && (result?.data?.code != 500)) {
                toast.success(response);
                onApplyFilter(response);
                onClearFilter(!clearFilter);
                dispatch(saveFilterGameUpdating(!filterGameUpdating))
            } else {
                toast.error("Failed to apply filters. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while applying filters.");
        }
        setTimeout(() => setIsClearDisabled(false), 3000);
    };

    useEffect(() => {
          getLocationName(profileData?.baseProfile?.latitude, profileData?.baseProfile?.longitude)
            .then((address) => {
                setProfileLocation(address)
            });
        switch (selectedLocation) {
            case 'Profile Location':
                setLocation({ latitude: profileData?.baseProfile?.latitude, longitude: profileData?.baseProfile?.longitude })
                break;

            case 'Current Location':
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        (position) => {
                            const { latitude, longitude } = position.coords;
                            getLocationName(latitude, longitude)
                                .then((address) => {
                                    setCurrentLocation(address)
                                });
                            setLocation({ latitude: latitude, longitude: longitude })
                        },
                        (error) => {
                            console.error('Error fetching location:', error);
                        }
                    );
                }
                break;

            case 'Other':
                break;

            default:
                // console.log('No location selected');
                break;
        }
    }, [selectedLocation]);

    useEffect(() => {
        const fetchProfileFilterData = async () => {
            try {
                const result = await apiHandler({
                    url: endpoint.FETCH_GAME_FILTER_DATA,
                    method: "GET",
                    authToken: accessToken?.accessToken
                });
                if (result.data) {
                    setLocation({
                        latitude: result.data.latitude,
                        longitude: result.data.longitude
                    });
                    const apiLat = result.data.latitude;
                    const apiLng = result.data.longitude;
                    const storedCoordinates = JSON.parse(localStorage.getItem("coordinates"));

                    setLocation({ latitude: apiLat, longitude: apiLng });

                    if (
                        apiLat === profileData?.baseProfile?.latitude &&
                        apiLng === profileData?.baseProfile?.longitude
                    ) {
                        setSelectedLocation("Profile Location");
                    } else if (

                        apiLat === storedCoordinates?.latitude &&
                        apiLng === storedCoordinates?.longitude
                    ) {
                        setSelectedLocation("Current Location");
                    } else {
                        setSelectedLocation("Other");
                    }
                    console.log('backend maxDistance 🔴', result.data.maxDistance);

                    setDistance(Number((result.data.maxDistance * METERS_TO_MILES).toFixed(2))); // converting meters into miles

                    setSelectedSports(result.data.sportName ?? '');
                    if (Array.isArray(result.data.skillLevel)) {
                        const formattedSkillLevels = Array.from(new Set(
                            result.data.skillLevel.map(level =>
                                typeof level === 'string'
                                    ? level
                                        .replace(/_/g, '-')
                                        .toLowerCase()
                                        .replace(/(^\w{1})|(-\w{1})/g, match => match.toUpperCase())
                                    : ''
                            )
                        ));
                        setSelectedLevel(formattedSkillLevels);
                    } else if (typeof result.data.skillLevel === 'string') {
                        const formatted = result.data.skillLevel
                            .replace(/_/g, '-')
                            .toLowerCase()
                            .replace(/(^\w{1})|(-\w{1})/g, match => match.toUpperCase());
                        setSelectedLevel([formatted]);
                    } else {
                        setSelectedLevel([]);
                    }

                    setSelectedDays(
                        result.data.days
                            ? result.data.days.map((day) => day.toLowerCase())
                            : []
                    );

                    setSelectedTimeRanges(
                        result.data.timeSlots
                            ? result.data.timeSlots.map((time) => time.toLowerCase())
                            : []
                    );

                    if (Array.isArray(result.data.endDate)) {
                        const [year, month, day] = result.data.endDate;

                        // Pad month and day with 0 if needed
                        const formatted = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                        setFormattedEndDate(formatted);
                        setEndDate(formatted)

                    } else if (typeof result.data.endDate === 'string') {
                        setFormattedEndDate(result.data.endDate);

                    } else {
                        setFormattedEndDate('');
                    }



                }
            } catch (error) {
                console.error("Error fetching filter data", error);
            }
        };

        fetchProfileFilterData();
        // dispatch(saveFilterUpdating(!filterUpdating))
    }, [accessToken]);

    const accordionItems = [
        {
            title: 'Filter By Location & Distance',
            content:
                <>
                    <div className="p-2 p-sm-4 border rounded shadow-sm">
                        <FilterLocation onLocationChange={onLocationChange} gameFilter = {true}/>
                        <h5 className="mb-3">Distance</h5>
                        <div className="d-flex align-items-center">
                            <input
                                type="range"
                                className="form-range-filter-page me-2"
                                min={5}
                                max={100}
                                value={distance}
                                onChange={(e) => setDistance(Number(e.target.value))}
                            />
                            <span className="badge bg-primary">{distance} mi</span>
                        </div>
                    </div>

                </>
        },
        {
            title: 'Filter By Date , Days & Time',
            content: <div className="date-days-time-picker container mt-4 p-3 rounded shadow">
                <div className="mb-4">
                    <label htmlFor="endDate" className="form-label mb-4" >
                        Choose End Date
                    </label>

                    <div className="w-100 w-sm-50">
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            customInput={<CustomDatePicker  placehold ="Choose Date..." />}
                            dateFormat="MMMM d, yyyy"
                            showMonthDropdown
                            showYearDropdown
                            dropdownMode="select"
                            wrapperClassName="date-picker-wrapper"
                            className="date-picker-input"
                           
                        />
                    </div>
                </div>

                <div className="mb-4">
                    <h6 className=" form-label ">Choose Time Range</h6>
                    <div className="d-flex flex-wrap gap-2 gap-sm-3">
                        {timeRanges.map((time) => (
                            <div className="form-check" key={time.value}>
                                <input
                                    type="checkbox"
                                    className="form-check-input "
                                    id={time.value}
                                    value={time.value}
                                    checked={selectedTimeRanges.includes(time.value)}
                                    onChange={() => handleTimeRangeChange(time.value)}
                                />
                                <label
                                    className={`form-check-label filter-skill-level ${selectedTimeRanges.includes(time.value) ? 'color-dark' : ''}`}
                                    htmlFor={time.value}
                                >
                                    {time.label}
                                </label>
                            </div>
                        ))}
                    </div>

                </div>

                <div className="mb-4">
                    <h6 className="form-label">Choose Days</h6>
                    <div className="d-flex flex-wrap row-gap-2 column-gap-4 gap-sm-3">
                        {days.map((day) => (
                            <div className="form-check" key={day.value}>
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    id={day.value}
                                    value={day.value}
                                    checked={selectedDays.includes(day.value)}
                                    onChange={() => handleDayChange(day.value)}
                                />
                                <label
                                    className={`form-check-label filter-skill-level ${selectedDays.includes(day.value) ? 'color-dark' : ''}`}
                                    htmlFor={day.value}
                                >
                                    {day.label}
                                </label>
                            </div>
                        ))}
                    </div>

                </div>
            </div>,
        },
        {
            title: 'Filter By Levels',
            content: (
                <div className="list-group border rounded p-2 p-sm-3 shadow-sm">
                    {["Beginner", "Intermediate", "Upper-Intermediate", "Proficient", "League Player"].map((value) => (
                        <div className="form-check mb-2" key={value}>
                            <input
                                type="checkbox"
                                className="form-check-input"
                                id={value}
                                value={value}
                                checked={selectedLevel.includes(value)}
                                onChange={() => handleLevelChange(value)}
                            />
                            <label
                                className={`form-check-label filter-skill-level ${selectedLevel.includes(value) ? 'color-dark' : ''}`}
                                htmlFor={value}
                            >
                                {value}
                            </label>
                        </div>
                    ))}
                </div>
            ),
        },
        {
            title: 'Filter By Sports',
            content: <div className="list-group border rounded p-3 shadow-sm">
                {["Tennis", "Pickleball"].map((sport) => (
                    <div className="form-check mb-2" key={sport}>
                        <input
                            type="checkbox"
                            className="form-check-input"
                            id={sport}
                            value={sport}
                            checked={selectedSports?.includes(sport)}
                            onChange={() => handleSportChange(sport)}
                        />
                        <label className={`form-check-label filter-skill-level ${selectedSports == sport ? 'color-dark' : ''}`} htmlFor={sport}>
                            {sport}
                        </label>
                    </div>
                ))}
            </div>

        }
    ];

    const onClickFilter = async () => {
        setIsClearDisabled(true);
        try {
            const result = await apiHandler({
                url: endpoint.REMOVE_FILTER_GAME,
                method: "POST",
                authToken: accessToken?.accessToken,
            });

            const response = result?.data?.message;
            if ((response == "Filter created" || "No filters found to be cleared") && (result?.data?.code != 500)) {
                toast.success(response);

                onClearFilter(!clearFilter);
            } else {
                toast.error("Failed to apply filters. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred while applying filters.");
        }
        setTimeout(() => setIsClearDisabled(false), 3000);
    }

    return (
        <>
            <div className="d-flex justify-content-center align-items-center">
                <div className="container" >
                    <div className="row py-3">
                        <div className="d-flex justify-content-between ps-4 pe-4 pb-4">
                            <div style={{ color: '#006FFD', fontWeight: '600', cursor: 'pointer' }} onClick={onCancel}>Cancel</div>
                            <div style={{ color: '#1F2024', fontWeight: '600', cursor: 'pointer' }}>Filter</div>
                            <button style={{ color: '#FF616D', fontWeight: '600', cursor: 'pointer', background: 'none', border: 'none' }} onClick={() => onClickFilter()} disabled={isClearDisabled} >Clear All</button>
                        </div>
                        <CustomAccordian items={accordionItems} />
                        <div className="pt-3" style={{ marginTop: '40px' }}>
                            <CustomButton buttonText={'Apply Filter'} style={{ width: '100%', height: '48px', borderRadius: '12px', background: '#006FFD', color: '#FFFFFF', border: 'none' }} onClick={handleApplyFilter} disabled={isClearDisabled} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default FilterPage;
